import { frontendURL } from '../../helper/URLHelper';

const campaigns = accountId => ({
  routes: ['settings_account_campaigns', 'one_off', 'email', 'outbound_calling'],
  menuItems: {
    back: {
      icon: 'ion-ios-arrow-back',
      label: 'HOME',
      hasSubMenu: false,
      toStateName: 'home',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
    },
    ongoingCampaigns: {
      icon: 'ion-arrow-swap',
      label: 'ONGOING',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/ongoing`),
      toStateName: 'settings_account_campaigns',
    },
    onOffCampaigns: {
      icon: 'ion-radio-waves',
      label: 'ONE_OFF',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
    emailCampaigns: {
      icon: 'ion-ios-email',
      label: 'EMAIL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/email`),
      toStateName: 'email',
    },
    callingCampaigns: {
      icon: 'ion-ios-telephone',
      label: 'OUTBOUND_CALLING',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/outbound_calling`),
      toStateName: 'outbound_calling',
    }
  },
});

export default campaigns;
